var _ = require('optimizely-client-fn');

/**
 * @constructor
 */
function StoreClass(id, flux, spec) {
  this.__id = id;
  this.__flux = flux;
  this.__stateId = 0;
  this.__hasChanges = false;
  this.__handlers = {} as any;

  _.extend(this, spec);
  this.__state = {} as any;

  if (this.initialize) {
    this.initialize();
  }
}

/**
 * @param {string} type
 * @param {Object} [payload]
 */
StoreClass.prototype.__handleAction = function(type:string, payload?:any) {
  var handler = this.__handlers[type];
  if (handler && typeof handler === 'function') {
    handler.call(this, payload, type);
  }
};

/**
 * Serialize the store state. Note that this uses `_.cloneDeep` which could be pretty expensive.
 * @returns {*}
 * @private
 */
StoreClass.prototype.__getState = function(): any {
  return _.cloneDeep(this.__state);
};

/**
 * @param {string} actionType
 * @param {Function} handler
 */
StoreClass.prototype.on = function(actionType:string, handler:Function) {
  this.__handlers[actionType] = _.bind(handler, this);
};

/**
 * Setups a handler that is invoked anytime the store's state
 * changes denoted by calling `__emitChange`
 */
StoreClass.prototype.observe = function(handler) {
  return this.__flux.__addObserver(this.__id, handler);
};

/**
 * Helper function to emit change event
 */
StoreClass.prototype.emitChange = function() {
  this.__hasChanges = true;
  this.__stateId++;
};

StoreClass.prototype.hasChanges = function() {
  return this.__hasChanges;
};

StoreClass.prototype.resetChange = function() {
  this.__hasChanges = false;
};

StoreClass.prototype.getStateId = function() {
  return this.__stateId;
};

/**
 * This resets all state on the store, this is possible
 * only if the StoreClass.initialize() function reset all stateful properties
 * on the store
 */
StoreClass.prototype.__reset = function() {
  if (this.reset && typeof this.reset === 'function') {
    this.reset();
  }
  this.initialize();
};

module.exports = StoreClass;
